import VModel from "@/vuetify_custom/v-modal_v1";
import { postSellOrderDownImportItemsApi } from "./services";

export default {
  data() {
    return {
      id: "",
      visible: false,
      filePath: "",
    };
  },
  methods: {
    show(id) {
      this.id = id;
      this.visible = true;
      this.filePath = "";
    },
    close() {
      this.visible = false;
    },
    submit() {
      if (!this.filePath) {
        this.$Message.error("请选择文件");
        return;
      }

      const formData = new FormData();
      formData.append("data_file", this.filePath);
      formData.append("id", this.id);
      console.log(formData);

      postSellOrderDownImportItemsApi(formData).then((res) => {
        this.visible = false;
        this.$emit("success");
        this.$Message.success("导入成功");
      });
    },
  },
  render() {
    return (
      <VModel
        v-model={this.visible}
        persistent
        dynamic-height
        height-rate={0.7}
        title={"导入SKU"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <div>
          <input type="file" v-model={this.filePath} />
        </div>
      </VModel>
    );
  },
};
